import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {AddContactPage} from '../add-contact/add-contact.page';
import {DocumentModel} from '../../models/document.model';
import {ContactModel} from '../../models/contact.model';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {GeneralService} from '../../services/general.service';
import {ActionModel} from '../../models/action.model';
import {StateManagerService} from '../../services/state-manager.service';

@Component({
    selector: 'app-search-contact',
    templateUrl: './search-contact.page.html',
    styleUrls: ['./search-contact.page.scss'],
})
export class SearchContactPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() action: ActionModel;
    contactList: ContactModel[] = [];
    queryText = '';

    constructor(public modalController: ModalController,
                private loadingController: LoadingController,
                private refreshDB: RefreshdatabaseService,
                private testConnection: TestConnectionService,
                private generalService: GeneralService,
                private stateManager: StateManagerService) {
    }

    async ngOnInit() {
        await this.populateContactList();
    }

    async ionViewDidEnter() {
    }

    async populateContactList() {
        this.contactList = [];
        if (this.document) {
            this.contactList = await this.stateManager.getCollection('contact');
            this.contactList = this.contactList.filter(contact => {
                return contact.cust === this.document.customer.cod;
            });
        } else {
            if (this.action && this.action.customerDTO.cod) {
                this.contactList = await this.stateManager.getCollection('contact');
                this.contactList = this.contactList.filter(contact => {
                    return contact.cust === this.action.customerDTO.cod;
                });
            } else {
                this.contactList = await this.stateManager.getCollection('contact');
            }
        }
        if (this.document && this.document.contact.name && !this.document.contact.$loki) {
            this.contactList.push(this.document.contact);
        }
        console.log(this.contactList);
        this.contactList = this.contactList.filter(elem => {
            return elem.name;
        });
        this.contactList.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
    }

    async openModalAddContact() {
        const modalAdd = await this.modalController.create({
            component: AddContactPage,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });

        modalAdd.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.modalController.dismiss(dataReturned.data);
            }
        });
        return await modalAdd.present();
    }

    fetchContacts(event) {
        this.testConnection.pingServer().then(() => {
            this.refreshDB.refreshContactsResource().then(() => {
                this.populateContactList();
                event.target.complete();
            });
        }).catch(err => {
            event.target.complete();
            this.generalService.createToast('No connection to the server');
        });
    }
}
